/***************************************************************************

    Copyright (C) 2020 Ravenpod, Inc.
    All rights reserved.

    This material contains CONFIDENTIAL INFORMATION
    that is the property of Ravenpod.com, Inc.
    Any unauthorized use, duplication or disclosure is prohibited.

***************************************************************************/
// Adding methods to base prototypes

if (!Array.prototype.last) {
    Array.prototype.last = function(){
        return this[this.length - 1];
    };
}

if (!Array.prototype.first){
    Array.prototype.first = function(){
        return this[0];
    };
}

/**
* Returns an array with arrays of the given size.
*
* @param myArray {Array} array to split
* @param chunk_size {Integer} Size of every group
*/
if (!Array.prototype.chunkArray) {
    Array.prototype.chunkArray = function(chunk_size) {
        let index = 0;
        let arrayLength = this.length;
        let tempArray = [];
        
        for (index = 0; index < arrayLength; index += chunk_size) {
            let myChunk = this.slice(index, index+chunk_size);
            // Do something if you want with the group
            tempArray.push(myChunk);
        }    
        return tempArray;    
    }    
}

if (!Array.prototype.uniqueOnly) {
    Array.prototype.uniqueOnly = function() {
        return [...new Set(this)];
    }
}

if (!Array.prototype.maxValueInAttributes) {
    Array.prototype.maxValueInAttributes = function(...attributeNames) {
        // attributeNames - ['completion_time', 'contrast_completion_time']
        // Generate this to 'ele.completion_time, ele.contrast_completion_time'
        let str1 = attributeNames.map( (attr) => {
            return `ele.${attr}`
        }).join(',')
        // Convert it to '[ele.completion_time, ele.contrast_completion_time] '
        let str2 = `[${str1}]`
        let allValues = (this.map((ele) => { 
            return eval(str2)
            // return [ele.completion_time, ele.contrast_completion_time] 
        })).flat().filter( (el) => { return el != null} );
        return Math.max(...allValues);    
    }
}

if (!Array.prototype.nonNull) {
    Array.prototype.nonNull = function() {
        return this.filter(n => n);    
    }
}